import { render, staticRenderFns } from "./ProductLocationMap.vue?vue&type=template&id=bf0ec7fc&scoped=true"
import script from "./ProductLocationMap.vue?vue&type=script&lang=js"
export * from "./ProductLocationMap.vue?vue&type=script&lang=js"
import style0 from "./ProductLocationMap.vue?vue&type=style&index=0&id=bf0ec7fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf0ec7fc",
  null
  
)

export default component.exports